export default function () {
  return {
    state: {
    },
    getters: {
    },
    actions: {
    },
    mutations: {
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/store.js